import { collection, doc, getDoc, getDocs, query, where, limit } from "firebase/firestore";
import { db } from "./firebase";
import { POSITIONS } from "./constants";

// ── Question Bank ──────────────────────────────────────────────────────────

export async function fetchScenarioFromBank(position, level, shownIds=[]) {
  const tried = new Set(shownIds);
  const maxTries = 20;
  const normalize = s => ({...s, correctIndices: s.correctIndices || (s.correctIndex!==undefined?[s.correctIndex]:[0])});

  for (let i=0;i<maxTries;i++) {
    const index = Math.floor(Math.random()*60)+1;
    const docId = `${position}_${level}_${String(index).padStart(3,"0")}`;
    if (tried.has(docId)) continue;
    tried.add(docId);
    const snap = await getDoc(doc(db,"questions",docId));
    if (snap.exists()) return normalize({id:docId,...snap.data()});
  }
  const snap = await getDocs(query(collection(db,"questions"),where("position","==",position),where("level","==",level),limit(5)));
  if (!snap.empty) {
    const avail = snap.docs.filter(d=>!shownIds.includes(d.id));
    const chosen = avail.length>0 ? avail[Math.floor(Math.random()*avail.length)] : snap.docs[0];
    return normalize({id:chosen.id,...chosen.data()});
  }
  return fetchScenarioFromAnthropic(position,level,"Player");
}

export async function fetchScenarioFromAnthropic(position,level,playerName) {
  const posLabel = POSITIONS.find(p=>p.id===position)?.label||position;
  const diffMap = { intermediate:"standard Little League plays", advanced:"double plays, bunt coverage, relay throws" };
  const mcJson = `{"type":"multiple_choice","outs":<0-2>,"runners":[...],"inning":<number>,"half":"top|bottom","teamScore":<n>,"opponentScore":<n>,"situation":"<full situation>","ballInPlay":"<what happens>","specialNote":"<or empty>","question":"<question>","choices":["A....","B....","C....","D...."],"correctIndices":[<0-3>],"explanation":"<explanation>"}`;
  const prompt = `Baseball coach for ${playerName} playing ${posLabel} at ${level} level. Multiple choice defensive scenario. Difficulty: ${diffMap[level]||"standard"}. Return ONLY JSON: ${mcJson}`;
  const res = await fetch("https://api.anthropic.com/v1/messages",{
    method:"POST",
    headers:{"Content-Type":"application/json","x-api-key":process.env.REACT_APP_ANTHROPIC_API_KEY,"anthropic-version":"2023-06-01","anthropic-dangerous-direct-browser-access":"true"},
    body:JSON.stringify({model:"claude-sonnet-4-20250514",max_tokens:800,messages:[{role:"user",content:prompt}]}),
  });
  const data = await res.json();
  const raw  = data.content?.map(b=>b.text||"").join("")||"";
  const q    = JSON.parse(raw.replace(/```json\n?|```/g,"").trim());
  return {...q, correctIndices: q.correctIndices||(q.correctIndex!==undefined?[q.correctIndex]:[0])};
}
